import styled from 'styled-components';
import { PageTableWrapperStyled } from 'styles/common.styles';

export const JobCodesHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const JobCodesTableWrapperStyled = styled(PageTableWrapperStyled)`
  .ant-table-pagination {
    justify-content: flex-end;
  }

  /* Column headers — match Jobs Library */
  .ant-table-thead > tr > th {
    font-size: 14px;
    font-weight: 500;
    line-height: 16.94px;
    color: ${({ theme }) => theme.colors.dark} !important;
  }

  /* Row cells — match Jobs Library */
  .ant-table-tbody > tr > td {
    font-size: 14px;
    font-weight: 500;
    line-height: 16.94px;
    color: ${({ theme }) => theme.colors.dark} !important;
  }

  /* Row hover — match Jobs Library */
  .ant-table-tbody > tr:hover > td {
    background-color: ${(p) => p.theme?.colors?.tableRowHoverBg ?? '#ECE5D8'} !important;
  }

  /* Page number items — locked to same values as Jobs Library (Ant Design defaults) */
  .ant-pagination-item a {
    font-size: 14px;
    font-weight: 400;
    font-family: inherit;
    color: ${({ theme }) => theme.colors.dark};
  }

  .ant-pagination-item-active a {
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.primary};
  }

  .ant-pagination-prev button,
  .ant-pagination-next button {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.dark};
  }

  .ant-select-selector {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.dark};
  }
`;
